export type PDFImagePlacement = {
    x: number;
    y: number;
    width: number;
    height: number;
};

/**
 * Scales an image down to fit a PDF page without distorting it, and centers it on the page.
 * Keeping the aspect ratio matters whenever the image holds something that must stay square,
 * such as a QR code.
 */
export function fitImageToPage(
    imageWidth: number,
    imageHeight: number,
    pageWidth: number,
    pageHeight: number
): PDFImagePlacement {
    if (imageWidth <= 0 || imageHeight <= 0) {
        return { x: 0, y: 0, width: pageWidth, height: pageHeight };
    }

    const scale = Math.min(pageWidth / imageWidth, pageHeight / imageHeight);
    const width = imageWidth * scale;
    const height = imageHeight * scale;

    return { x: (pageWidth - width) / 2, y: (pageHeight - height) / 2, width, height };
}
